export const USERS_TYPES = {
   teacher: 'PROFESOR',
   student: "ESTUDIANTE",
   staff: 'STAFF',
   director: 'DIRECTOR',
   codirector: 'CO-DIRECTOR',
   coordinator: 'COORDINADOR'
}